export default __webpack_public_path__ + "static/media/netscape.a701da74.gif";